import React from "react";
import { Col, Row } from "react-bootstrap";

import ProgressBar from 'react-bootstrap/ProgressBar';

function Techstack(props) {
  return (
    <>
    <Row style={{ justifyContent: "left", paddingBottom: "10px" }}>
       <Col className="skill-name" xs={10}  >
        {props.name}
        <ProgressBar animated now={props.initialRating} max={5} color={"red"} />
      </Col>
      <Col xs={6}>
        {/* <Rating
          readonly
          start={0}
          stop={5}
          initialRating={props.initialRating}
          className="rating"
        /> */}
      </Col>
    </Row>
    </>
  );
}

export default Techstack;
